/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pxk_Sorting_Notes_EmptyInputs */

const vi_pl_pxk_sorting_notes_empty = /** @type {(inputs: Pl_Pxk_Sorting_Notes_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có phiếu nhập kho phân loại nào.`)
};

/**

* @param {Pl_Pxk_Sorting_Notes_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pxk_sorting_notes_empty = /** @type {((inputs?: Pl_Pxk_Sorting_Notes_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pxk_Sorting_Notes_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pxk_sorting_notes_empty(inputs)
});